var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-elements" },
    [
      _c("div", { staticClass: "kyc-information-status" }, [
        _c("fieldset", { staticClass: "info-group senior-top" }, [
          _c("legend", { staticClass: "senior-title" }, [
            _vm._v(_vm._s(_vm.$t("kyc.kycInformation"))),
          ]),
          _vm.kycStatus === "saved"
            ? _c("div", { staticClass: "senior-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm comfirm-ok",
                    on: { click: _vm.savedAll },
                  },
                  [_vm._v(_vm._s(_vm.$t("kyc.save")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger btn-sm comfirm-ok",
                    on: { click: _vm.submitAll },
                  },
                  [_vm._v(_vm._s(_vm.$t("basic.button.submit")))]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "vuestic-widget",
        [
          _vm.kycStatus === "firstEdit"
            ? _c(
                "SimpleHorizontalIndicator",
                {
                  ref: "simpleHorizontalIndicator",
                  attrs: {
                    steps: _vm.steps,
                    wizardType: "simple",
                    wizardLayout: "horizontal",
                    currentComponent: _vm.currentComponent,
                  },
                  on: {
                    wizardComplete: _vm.wizardComplete,
                    changeCurrentStep: _vm.changeCurrentStep,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-wizard-tab-content",
                      attrs: { slot: "first" },
                      slot: "first",
                    },
                    [
                      _vm.currentComponent === "basicInformation"
                        ? _c("basic-infomation", {
                            ref: "basicInfo",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentComponent === "licenseInformation"
                        ? _c("license-information", {
                            ref: "licenseInfo",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentComponent === "uploadAttachment"
                        ? _c("upload-attachment", {
                            ref: "uploadAttachment",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "form-wizard-tab-content",
                      attrs: { slot: "second" },
                      slot: "second",
                    },
                    [
                      _vm.currentComponent === "businessInformation"
                        ? _c("business-information", {
                            ref: "businessInformation",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentComponent === "bankInformation"
                        ? _c("bank-information", {
                            ref: "bankInfo",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentComponent === "seniorManagement"
                        ? _c("senior-management", {
                            ref: "seniorManage",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentComponent === "ultimateBeneficiary"
                        ? _c("ultimate-beneficiary", {
                            ref: "ultimateBenefit",
                            attrs: { kycStatus: _vm.kycStatus },
                            on: {
                              updateKycInformation: function ($event) {
                                return _vm.updateKycInformation(arguments)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "form-wizard-tab-content",
                      attrs: { slot: "three" },
                      slot: "three",
                    },
                    [
                      _vm.currentComponent === "complianceQuestionnaire"
                        ? _c("compliance-questionnaire", {
                            ref: "compliance",
                            attrs: { kycStatus: _vm.kycStatus },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.kycStatus === "saved" || _vm.kycStatus === "submitted"
            ? _c(
                "div",
                [
                  _c("basic-infomation", {
                    ref: "basicInfo",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                      changeRegionHK: _vm.changeRegionHK,
                    },
                  }),
                  _c("license-information", {
                    ref: "licenseInfo",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                    },
                  }),
                  _c("upload-attachment", {
                    ref: "uploadAttachment",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                    },
                  }),
                  _c("div", { staticClass: "kyc-saved-m" }),
                  _c("business-information", {
                    ref: "businessInformation",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                    },
                  }),
                  _c("div", { staticClass: "kyc-saved-m" }),
                  _c("bank-information", {
                    ref: "bankInfo",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                    },
                  }),
                  _c("div", { staticClass: "kyc-saved-m" }),
                  _c("senior-management", {
                    ref: "seniorManage",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                      changeUltimateBeneficiary: _vm.changeUltimateBeneficiary,
                    },
                  }),
                  _c("ultimate-beneficiary", {
                    ref: "ultimateBenefit",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                    on: {
                      updateKycInformation: function ($event) {
                        return _vm.updateKycInformation(arguments)
                      },
                      changeSeniorManagement: _vm.changeSeniorManagement,
                    },
                  }),
                  _c("div", { staticClass: "kyc-saved-m" }),
                  _c("compliance-questionnaire", {
                    ref: "compliance",
                    attrs: {
                      kycStatus: _vm.kycStatus,
                      merchantData: _vm.merchantData,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }